
export default class accessibleMenu
{
    constructor ()
    {
        $('.ae-navbar-nav > li').each(function () {
            $(this).addClass('focus-control');
        });

        $('.ae-navbar-nav li a').focusout(function () {
            var sel = this;
            setTimeout(function () {
                if (!$(sel).parents('.focus-control').find('a:focus').length) {
                    $(sel).parents('.focus-control').removeClass('focus-active');
                }
            }, 50);
        });

        $('.ae-navbar-nav > li > span').keydown(function (e) {
            var p = e.which;
            if (p == 13 && $(this).parent('li').find('.ae-dropdown-menu').length) {
                e.preventDefault();
                if ($(this).parents('li').hasClass('focus-active')) {
                    $(this).parents('li').removeClass('focus-active');
                } else {
                    $(this).parents('li').addClass('focus-active');
                }
            }
        });

        $('.ae-navbar-nav > li > span').click(function (e) {
            if ($(this).parent('li').find('.ae-dropdown-menu').length) {
                e.preventDefault();
                if ($(this).parents('li').hasClass('focus-active')) {
                    $(this).parents('li').removeClass('focus-active');
                } else {
                    $('.nav.ae-navbar-nav li').removeClass('focus-active');
                    $(this).parents('li').addClass('focus-active');
                }
            }
        });
    }
}
